/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
    var clientWidth = el.clientWidth;

    var _getComputedStyle = getComputedStyle(el);

    var paddingLeft = _getComputedStyle.paddingLeft;
    var paddingRight = _getComputedStyle.paddingRight;

    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-custom-scrollbars/lib/utils/getInnerWidth.js
 ** module id = 1602
 ** module chunks = 0
 **/